import React from 'react';
import { Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import numeral from 'numeral';

/**
 * "N all-time / M last 30 days" counter for the contact/investor card header
 * (GEN "Save count of aggregate updates"). Counts are the aggregate (updates +
 * creations) of unique field changes tracked for the record.
 */
const RecordUpdatesBadge = ({ allTimeCount, last30DaysCount, fetching, titleClassName, subtitleClassName }) => (
  <div>
    <Typography variant="h5" className={titleClassName}>
      Updates
    </Typography>
    <span className={subtitleClassName}>
      {fetching
        ? <Skeleton width={70} />
        : `${numeral(allTimeCount || 0).format('0,0')} all-time / ${numeral(last30DaysCount || 0).format('0,0')} last 30 days`}
    </span>
  </div>
);

export default RecordUpdatesBadge;
